import { Prestation } from "./prestation";
import { User } from "./security/user";

export class NotificationEmail {
    id: number;
    title: string;
    type: string;
    message: string;
    actif: boolean;
}

export class SendEmail {
    notificationEmail: NotificationEmail;
    prestation: Prestation;
    email: string;
    user: User;
    urlReinitPassword: string;
}


